import axios, { AxiosRequestConfig, Method } from "axios";
import { useContext, useEffect, useState } from "react";
import { NestError } from "../api/dto/nest-error.dto";
import { api_constants } from "../constants/api.constants";

interface useFetchProps {
    method: Method
    endpoint: string
    body?: any|null
    params?: any|null
    navigation?: any|null
    useBaseUrl?: boolean
    headers?: any
    responseType?: any
    useToken?: boolean
}

interface RefetchProps {
    body?: any|null
    params?: any|null
    endpoint?: string|null
}

const useFetch = <T extends {}>({ method, endpoint, body=null, params=null, navigation=null, useBaseUrl=true, headers={}, responseType=null, useToken=true }: useFetchProps) => {
    const base_url = api_constants.urls.base_url

    const formatUrl = (sub_url: string) => `${useBaseUrl ? base_url : ""}${sub_url}`

    const [data, setData] = useState<T|null>()
    const [status, setStatus] = useState<number|null>(null)
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState<NestError|null>(null)
    // const contextProps = useContext(AppContext)
    // const realm = useRealm()

    const options: AxiosRequestConfig<any> = {
        method: method,
        url: formatUrl(endpoint),
        headers: {...headers},
        responseType: responseType,
        data: body,
        params: { ...params },
    };
  
    const fetchData = async () => {
        setIsLoading(true);
  
        try {
            const response = await axios.request(options);
            
            setStatus(response.status)
  
            setData(response.data);

            setIsLoading(false);
            setError(null)

            return { data: response.data, status: response.status }
        } catch (error) {
            if (axios.isAxiosError(error)) {
                if (error.response) {
                    // Server responded with a status code outside of 2xx range
                    console.log('Error response status:', error.response.status);
                    setStatus(error.response.status)
                    setError(error.response.data);

                    if(navigation && error.response.status === 401) {
                        // AuthService.token.offlineSignOut(navigation, contextProps, realm)
                    }

                    console.log(`Error response data `, error.response.data);
                } else if (error.request) {
                    // The request was made but no response was received
                    const err = { message: "Could not connect to server" } as NestError
                    setError(err);
                    console.log('No response received:', error.request);
                } else {
                    const err = { message: "Request setup error" } as NestError

                    setError(err);
                    // Something happened in setting up the request that triggered an error
                    console.log('Request setup error:', error.message);
                }
            } else {
                // Non-Axios error
                const err = { message: "Non-axios error" } as NestError
                setError(err);
                console.log("Non axios error")
                // console.error('Error:', error.message);
            }
    
        } finally {
            setIsLoading(false);
        }
    };
  
    useEffect(() => {
        // fetchData();
    }, []);
  
    const refetch = async(props?: RefetchProps) => {

        if(props && props.body) {
            options.data = props.body
        }

        if(props && props.params) {
            options.params = {...props.params}
        }

        if(props && props.endpoint) {
            options.url = formatUrl(props.endpoint)
        }

        // const tokenCache = await AuthService.token.getToken()

        setIsLoading(true);

        setStatus(null)

        // if(options.headers && tokenCache && tokenCache && useToken) {
        //     options.headers.Authorization = `Bearer ${tokenCache}`
        // }
        
        return await fetchData();
    };
  
    return { data, isLoading, error, refetch, setData, status };
};

export default useFetch